import React, {useState} from "react";
import {number} from "prop-types";

export const SecurityComponent = (props) => {

    const [pinState, setPinState] = useState('okay');
    const [showErrorA, setShowErrorA] = useState(false);
    const [showErrorB, setShowErrorB] = useState(false);

    const { user, postSecurityConfig, container, userSecurityProfile } = props;
    const [spinner, setSpinner] = useState(false);

    let isAuthenticated = (user !== null && user !== undefined);

    let pinCodePH = userSecurityProfile.pinCode;
    let [pinCode, setPinCode] = useState(pinCodePH);
    const pinCodeInitial = pinCodePH;

    // PH (means simply) -> place_holder

    let loggedUserEmail = userSecurityProfile.userEmail;
    let [userEmail, setUserEmail] = useState(loggedUserEmail);

    let pinSecurityPH = userSecurityProfile.pinSecurity;
    let [pinSecurity, setPinSecurity] = useState(pinSecurityPH);

    let voiceProfilePH = userSecurityProfile.voiceProfile;
    let [voiceProfile, setVoiceProfile] = useState(voiceProfilePH);

    let pinSecurityTypePH = userSecurityProfile.pinSecurityType;
    let [pinSecurityType, setPinSecurityType] = useState(pinSecurityTypePH);

    /*
     * These lines below are extremely important. Without them, the fields, e.g. pinSecurity
     * always re-initialize to 'undefined' and make correctly displaying buttons impossible.
     * I'm not sure WHY that is the case, but I need to (perhaps) post a stackoverflow question.
     */
    pinSecurity = pinSecurity !== null && pinSecurity !== undefined ? pinSecurity : pinSecurityPH;
    voiceProfile = voiceProfile !== null && voiceProfile !== undefined ? voiceProfile : voiceProfilePH;
    pinSecurityType = pinSecurityType !== null && pinSecurityType !== undefined ? pinSecurityType : pinSecurityTypePH;
    userEmail = userEmail !== null && userEmail !== undefined ? userEmail : loggedUserEmail;

    const [changed, setChanged] = useState(false);

    return (

        <>
            <div className={"ui middle centered aligned grid"}>
                <div className={"column"} style={{ maxWidth: 450 }}>
                    <h3 className="ui teal image header">
                        <div className={"content"}>
                            Security Configuration &nbsp; &nbsp;
                            {(container === "modal") ?
                                <span>
                                    <a href={"/security"}> <i className={"external alternate icon"}></i>  </a>
                                </span> : <></>
                            }
                        </div>
                    </h3>
                    <form className="ui large form">

                        {isAuthenticated ?
                            (<div className={"ui segment"}>

                                <div className={"field"}>
                                    <div className={"ui circular mini toggle checkbox"} data-tooltip="Allows app to recognize your voice"
                                         data-position="top left" data-inverted="">

                                        <input
                                            name={"voiceProfileInput"}
                                            type={"checkbox"}
                                            checked={voiceProfile === "enabled" ? "checked": ""}
                                            onChange={(e) => {
                                                setVoiceProfile(e.target.checked ? "enabled" : "disabled");
                                                setChanged(true);
                                            }}/>
                                            <label>Enable Voice Recognition <i className="question circle icon"></i></label>
                                    </div>
                                </div>


                                <div className={"field segment"}>
                                    <div className={"ui toggle checkbox"}>
                                        <input
                                            name={"pinSecurityInput"}
                                            type={"checkbox"}
                                            checked={pinSecurity === "enabled" ? "checked": ""}
                                            onChange={(e) => {
                                                setPinSecurity(e.target.checked ? "enabled" : "disabled");
                                                setChanged(true);
                                            }}/>
                                        <label>Enable Pin Security</label>
                                    </div>
                                </div>

                                <div className={`grouped fields ${pinSecurity}`} style={{"padding-top": "1rem", "padding-bottom": "1rem"}}>
                                    <div className={"field"}>
                                        <div className={"ui radio checkbox"}>
                                                <input
                                                    type={"radio"}
                                                    name={"pinSecurityType"}
                                                    checked={pinSecurityType === "fallback" ? "checked" : ""}
                                                    onChange={ (e) => {
                                                        setShowErrorB(false);
                                                        setPinSecurityType("fallback");
                                                        setChanged(true);
                                                    }}/>

                                            <label style={{display: "inline"}}>Fallback </label>
                                                <div style={{display: "inline"}} className={"ui circular mini toggle checkbox"} data-tooltip="Used only if your voice isn't recognized"
                                                     data-position="top left" data-inverted="">
                                                    <i className="question circle icon"></i>
                                                </div>
                                            </div>
                                    </div>
                                    <div className={"field"}>
                                        <div className={"ui radio checkbox"}>
                                            <input
                                                type={"radio"}
                                                name={"pinSecurityType"}
                                                checked={pinSecurityType === "mandatory" ? "checked" : ""}
                                                onChange={ (e) => {
                                                    setShowErrorB(false);
                                                    setPinSecurityType("mandatory");
                                                    setChanged(true);
                                                }}/>
                                            <label style={{display: "inline"}}> Mandatory </label>
                                            <div style={{display: "inline"}} className={"ui circular mini toggle checkbox"} data-tooltip="Required at every invocation"
                                                 data-position="top left" data-inverted="">
                                                <i className="question circle icon"></i>
                                            </div>
                                        </div>
                                        {showErrorB ?
                                            <div className="ui left pointing red basic label">
                                                Please select one
                                            </div> :
                                            <></>
                                        }
                                    </div>
                                </div>
                                <div className={`field ${pinSecurity} ${pinState}`}>
                                    <div className={`ui left icon input`}>
                                        <i className={"key icon"}></i>
                                        <input
                                            name = "pinCodeInput"
                                            type={"number"}
                                            maxLength={4}
                                            placeholder={pinCodePH}
                                            value={pinCode !== null && pinCode !== undefined ? pinCode : pinCodeInitial}
                                            onChange={(e) => {
                                                setShowErrorA(false)
                                                let runningValue = e.target.value;
                                                if (runningValue.toString().length !== 4) {
                                                    setPinState("error");
                                                } else {
                                                    setPinState("okay");
                                                }
                                                setPinCode(e.target.value);
                                                if (pinCode)
                                                setChanged(true);
                                            }}/>
                                    </div>
                                    {showErrorA ?
                                        <div className="ui pointing red basic label">
                                            Please enter a 4-digit pin.
                                        </div> :
                                        <></>
                                    }
                                </div>

                                    {changed ?
                                        <div className={"field"}>
                                            <br></br>
                                            {spinner ? (
                                                <div className={"ui fluid large teal loading button"}>
                                                    Submitting ...
                                                </div>) : (
                                                <div className={"ui fluid large teal submit button"} onClick={() => {

                                                    if (pinSecurity === "enabled") {
                                                        let error = false;
                                                        if (pinCode == null || pinCode == undefined || pinCode.toString().length !== 4) {
                                                            setShowErrorA(true);
                                                            error = true;
                                                        }

                                                        if (pinSecurityType !== "fallback" && pinSecurityType !== "mandatory") {
                                                            setShowErrorB(true);
                                                            error = true
                                                        }
                                                        if (error)
                                                            return;
                                                    }

                                                    /* Invoke the redux action to actually post the message*/
                                                    postSecurityConfig({
                                                        "userEmail": userEmail,
                                                        "pinCode": pinCode !== null && pinCode !== undefined ? parseInt(pinCode) : pinCodeInitial,
                                                        "voiceProfile": voiceProfile,
                                                        "pinSecurityType": pinSecurityType,
                                                        "pinSecurity": pinSecurity
                                                    });
                                                    setSpinner(true);
                                                    setTimeout(() => {
                                                        setSpinner(false);
                                                        setChanged(false);
                                                    }, 3000);
                                                }}>
                                                    Submit Changes
                                                </div>)
                                            }
                                        </div> : <br/>
                                    }
                            </div>) :
                            (<p> A valid user must be logged in to setup a security configuration </p>)
                        }
                        <a href={"https://www.amazon.com/gp/help/customer/display.html?nodeId=GYY4637XC2STFL9R"} target={"_blank"}>How do I create a Voice Profile for Alexa?</a>
                    </form>
                </div>
            </div>
        </>
    )
}
